import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { BROWSER_ERROR } from "@pdfking/translations/enum/errors"
import messages from "../state/messages"

export default CreateRenderFunction({
  data: {},
  mounted() {
    messages().send_error(BROWSER_ERROR)
  },
  render() {
    return null
  },
})
